@if (isUserSelected && !isEditing) {
  <app-activity-panel-small
    [selectedUser]="selectedUser"
  ></app-activity-panel-small>
}

<!-- Quick and dirty: canWritUsers should be replaced with activity-related check -->
@if (loading && canWriteUsers) {
  <ng-container>
    <div class="skeleton-container activity-table">
      <p-skeleton width="100%" height="2rem"></p-skeleton>
      <p-skeleton width="100%" height="2rem"></p-skeleton>
      <p-skeleton width="100%" height="2rem"></p-skeleton>
    </div>
  </ng-container>
}

<!-- Quick and dirty: canWritUsers should be replaced with activity-related check -->
@if (isUserSelected && !loading && !isEditing && canWriteUsers) {
  <div class="activity-table">
    @if (selectedUser.activities && selectedUser.activities.length > 0) {
      <table>
        <tr>
          <th></th>
          <th class="activity-name-col">Aktivität</th>
          <th>Aktualisiert</th>
        </tr>
        @for (activity of selectedUser.activities; track activity.activityId) {
          <tr
            (click)="openActivityDetails(activity.activityId)"
            class="activity-link"
          >
            <td>
              <app-activity-type
                [typeName]="activity.activityType.typeName"
              ></app-activity-type>
            </td>
            <td class="activity-name-col">{{ activity.activityName }}</td>

            <td>{{ activity.updatedAt | date: "dd.MM.YYYY" }}</td>
          </tr>
        }
      </table>
    } @else {
      <p>Keine Aktivitäten</p>
    }
  </div>
}

<form [formGroup]="newUserForm" class="dialog-two-columns">
  <!-- #region ROLLEN -->

  <div class="form-grid">
    <div>
      <div class="form-group">
        <p-multiSelect
          [options]="roles"
          placeholder="Rollen auswählen"
          formControlName="roleId"
          optionLabel="roleName"
          optionValue="roleId"
          inputId="roleId"
          [virtualScroll]="true"
          [virtualScrollItemSize]="50"
          width="100%"
        >
        </p-multiSelect>
      </div>

      <!-- App-ID vergibt das Backend erst beim Anlegen -->
      @if (isUserSelected) {
        <div
          class="p-field"
          [ngClass]="{
            'p-invalid':
              newUserForm.get('appId')?.invalid &&
              (newUserForm.get('appId')?.touched ||
                newUserForm.get('appId')?.dirty),
          }"
        >
          <p-floatLabel>
            <input
              pInputText
              id="appId"
              type="text"
              inputmode="numeric"
              maxlength="6"
              formControlName="appId"
            />
            <label for="appId">App-ID</label>
          </p-floatLabel>
          @if (
            newUserForm.get('appId')?.invalid &&
            (newUserForm.get('appId')?.touched ||
              newUserForm.get('appId')?.dirty)
          ) {
            <small class="p-error">Die App-ID muss 6-stellig sein (Ziffern 1–9, keine 0).</small>
          }
        </div>
      } @else {
        <small class="app-id-hint">
          Die App-ID wird nach dem Anlegen automatisch vergeben.
        </small>
      }
    </div>

    <!-- Nur lesend und nur bei bestehendem User; auf Höhe der App-ID -->
    @if (isUserSelected) {
      <div class="on-site-hours-column">
        <div class="p-field">
          <p-floatLabel>
            <input
              pInputText
              id="onSiteHours"
              type="text"
              [value]="
                onSiteHours === null
                  ? ''
                  : (onSiteHours | number: '1.1-1' : 'de-DE')
              "
              disabled
            />
            <label for="onSiteHours">Gesamtstunden vor Ort</label>
          </p-floatLabel>
        </div>
      </div>
    }
  </div>

  <!-- #endregion -->

  <!-- #region ALLGEMEIN -->

  <div class="form-grid">
    <div>
      <div
        class="p-field required-field"
        [ngClass]="{
          'p-invalid':
            newUserForm.get('firstname')?.invalid &&
            (newUserForm.get('firstname')?.touched ||
              newUserForm.get('firstname')?.dirty),
        }"
      >
        <p-floatLabel>
          <input
            pInputText
            [autofocus]="true"
            id="firstname"
            type="text"
            formControlName="firstname"
          />
          <label for="firstname">Vorname*</label>
        </p-floatLabel>
      </div>

      <div
        class="p-field required-field"
        [ngClass]="{
          'p-invalid':
            newUserForm.get('lastname')?.invalid &&
            (newUserForm.get('lastname')?.touched ||
              newUserForm.get('lastname')?.dirty),
        }"
      >
        <p-floatLabel>
          <input
            pInputText
            id="lastname"
            type="text"
            formControlName="lastname"
          />
          <label for="lastname">Nachname*</label>
        </p-floatLabel>
      </div>

      <div class="p-field">
        <p-floatLabel variant="in">
          <input pInputText id="street" type="text" formControlName="street" />
          <label for="street">Straße</label>
        </p-floatLabel>
      </div>

      <div class="p-field">
        <p-floatLabel variant="in">
          <input
            pInputText
            id="postalCode"
            type="text"
            formControlName="postalCode"
          />
          <label for="postalCode">PLZ</label>
        </p-floatLabel>
      </div>

      <div class="p-field">
        <p-floatLabel variant="in">
          <input pInputText id="city" type="text" formControlName="city" />
          <label for="city">Ort</label>
        </p-floatLabel>
      </div>
    </div>
    <div>
      <div
        class="p-field required-field"
        [ngClass]="{
          'p-invalid':
            newUserForm.get('phoneNumber')?.invalid &&
            (newUserForm.get('phoneNumber')?.touched ||
              newUserForm.get('phoneNumber')?.dirty),
        }"
      >
        <p-floatLabel>
          <input
            pInputText
            id="phoneNumber"
            type="text"
            formControlName="phoneNumber"
          />
          <label for="phoneNumber">Telefon</label>
        </p-floatLabel>
      </div>

      <div
        class="p-field required-field"
        [ngClass]="{
          'p-invalid':
            newUserForm.get('email')?.invalid &&
            (newUserForm.get('email')?.touched ||
              newUserForm.get('email')?.dirty),
        }"
      >
        <p-floatLabel>
          <input pInputText id="email" type="text" formControlName="email" />
          <label for="email">E-Mail</label>
        </p-floatLabel>
      </div>

      <div
        class="p-field required-field"
        [ngClass]="{
          'p-invalid':
            newUserForm.get('internEmail')?.invalid &&
            (newUserForm.get('internEmail')?.touched ||
              newUserForm.get('internEmail')?.dirty),
        }"
      >
        <p-floatLabel>
          <input pInputText id="internEmail" type="text" formControlName="internEmail" />
          <label for="internEmail">Interne E-Mail</label>
        </p-floatLabel>
      </div>
      

      <div class="p-field dropdown-crop">
        <p-floatLabel variant="in">
          <p-multiSelect
            [dataKey]="'courseId'"
            placeholder="Kurs auswählen"
            id="selectedCourses"
            [options]="courses"
            formControlName="selectedCourses"
            optionLabel="courseName"
            [maxSelectedLabels]="1"
            [selectedItemsLabel]="'{0} Kurse ausgewählt'"
            appendTo="body"
          />
          <label for="selectedCourses">Kurse</label>
        </p-floatLabel>
        @if (isEditing) {
          <button
            pButton
            type="button"
            label="Kurs erstellen"
            icon="pi pi-plus"
            class="p-button-text"
            (click)="showAddCourseDialog()"
          ></button>
        }
      </div>
      <div class="formgroup checkbox">
        <p-checkbox
          [binary]="true"
          id="isActive"
          formControlName="isActive"
        ></p-checkbox>
        <label class="checkbox-label" for="isActive"
          ><strong>Ist aktiv?</strong></label
        >
      </div>
    </div>
  </div>

  <!-- #endregion -->

  <!-- #region INTERESSENT -->

  <div class="form-grid" *ngIf="islead || isParticipant">
    <div>
      <div class="form-group">
        <p-floatLabel variant="in">
          <p-calendar
            inputId="birthDate"
            formControlName="birthDate"
            name="birthDate"
            dateFormat="dd.mm.yy"
            showIcon="true"
          ></p-calendar>
          <label for="birthDate">Geburtsdatum</label>
        </p-floatLabel>
      </div>

      <div class="p-field">
        <p-floatLabel variant="in">
          <input
            pInputText
            id="birthPlace"
            type="text"
            formControlName="birthPlace"
          />
          <label for="birthPlace">Geburtsort</label>
        </p-floatLabel>
      </div>

      <div class="form-group dropdown-crop">
        <p-floatLabel variant="in">
          <p-dropdown
            appendTo="body"
            [options]="genders"
            optionLabel="name"
            optionValue="short"
            placeholder="Erforderlich"
            id="gender"
            formControlName="gender"
          />
          <label for="gender">Geschlecht</label>
        </p-floatLabel>
      </div>

      <div class="form-group dropdown-crop">
        <p-floatLabel variant="in">
          <p-dropdown
            appendTo="body"
            [options]="educationLevels"
            id="educationLevel"
            formControlName="educationLevel"
          />
          <label for="educationLevel">Schulabschluss</label>
        </p-floatLabel>
      </div>

      <div class="form-group dropdown-crop">
        <p-floatLabel variant="in">
          <p-dropdown
            appendTo="body"
            [options]="careerInterests"
            id="careerInterest"
            formControlName="careerInterest"
          />
          <label for="careerInterest">Berufswahl</label>
        </p-floatLabel>
      </div>

      <div class="form-group">
        <p-floatLabel variant="in">
          <p-calendar
            inputId="contactDate"
            formControlName="contactDate"
            name="contactDate"
            dateFormat="dd.mm.yy"
            showIcon="true"
          ></p-calendar>
          <label for="contactDate">Datum des Kontakts</label>
        </p-floatLabel>
      </div>

      <div class="form-group dropdown-crop" *ngIf="islead">
        <p-floatLabel variant="in">
          <p-dropdown
            id="leadState"
            appendTo="body"
            [options]="leadStatus"
            formControlName="leadState"
          />
          <label for="leadState">Status</label>
        </p-floatLabel>
      </div>
    </div>

    <div>
      <div class="p-field">
        <p-floatLabel variant="in">
          <input
            pInputText
            id="customerId"
            type="text"
            formControlName="customerId"
          />
          <label for="customerId">Kundennummer</label>
        </p-floatLabel>
      </div>

      <div class="p-field">
        <p-floatLabel variant="in">
          <input
            pInputText
            id="clerkFirstname"
            type="text"
            formControlName="clerkFirstname"
          />
          <label for="clerkFirstname">Sachbearbeiter:in Vorname</label>
        </p-floatLabel>
      </div>

      <div class="p-field">
        <p-floatLabel variant="in">
          <input
            pInputText
            id="clerkLastname"
            type="text"
            formControlName="clerkLastname"
          />
          <label for="clerkLastname">Sachbearbeiter:in Nachname</label>
        </p-floatLabel>
      </div>

      <div class="p-field">
        <p-floatLabel variant="in">
          <input
            pInputText
            id="clerkEmail"
            type="text"
            formControlName="clerkEmail"
          />
          <label for="clerkEmail">Sachbearbeiter:in E-Mail</label>
        </p-floatLabel>
      </div>

      <div class="p-field">
        <p-floatLabel variant="in">
          <input
            pInputText
            id="clerkPhone"
            type="text"
            formControlName="clerkPhone"
          />
          <label for="clerkPhone">Sachbearbeiter:in Telefon</label>
        </p-floatLabel>
      </div>

      <div class="form-group dropdown-crop">
        <p-floatLabel variant="in">
          <p-dropdown
            appendTo="body"
            [options]="sponsors"
            optionLabel="sponsorName"
            id="sponsor"
            formControlName="sponsor"
          />
          <label for="sponsor">Kostenträger</label>
        </p-floatLabel>

        @if (isEditing) {
          <button
            pButton
            type="button"
            label="Kostenträger erstellen"
            icon="pi pi-plus"
            class="p-button-text"
            (click)="showAddSponsorDialog()"
          ></button>
        }
      </div>

      <div class="form-group checkbox" *ngIf="islead">
        <p-checkbox
          [binary]="true"
          id="financed"
          formControlName="financed"
        ></p-checkbox>
        <label class="checkbox-label" for="financed"
          >Finanzierung gesichert?</label
        >
      </div>
    </div>
  </div>

  @if (isParticipant && firstCourse) {
    <div class="result-container">
      <div style="display: flex; justify-content: space-between">
        <h3>Prüfungstermine</h3>
      </div>
      <div style="display: flex; gap: 2rem">
        <p>
          APT1:
          <strong>{{
            firstCourse.apt1Date
              ? (firstCourse.apt1Date | date: "dd.MM.yyyy")
              : "Unbekannt"
          }}</strong>
        </p>

        <p>
          APT2:
          <strong>{{
            firstCourse.apt2Date
              ? (firstCourse.apt2Date | date: "dd.MM.yyyy")
              : "Unbekannt"
          }}</strong>
        </p>
      </div>
    </div>
  }

  @if (isParticipant && showExamResults) {
    <div class="result-container">
      <div style="display: flex; justify-content: space-between">
        <h3>Prüfungsergebnisse</h3>
        <button
          pButton
          label="Ergebnis hinzufügen"
          icon="pi pi-plus"
          [text]="true"
          [raised]="true"
          class="add-result-button"
          (click)="showExamRecordDialog()"
        ></button>
      </div>
      <div style="display: flex; gap: 2rem">
        @for (record of examRecords; track record.id) {
          <p>
            {{ getExamTypeLabel(record.examType) }}:
            <strong>{{ record.examResult }}</strong>
          </p>
        }
      </div>
      <p-dialog
        [header]="'Prüfungsergebnis eintragen: ' + selectedUser.fullName"
        [(visible)]="isExamDialog"
        [modal]="true"
        [closable]="false"
        [draggable]="false"
        [style]="{ width: '35rem' }"
        [contentStyle]="{ overflow: 'visible' }"
      >
        <app-exam-record-dialog
          #examDialog
          [userId]="selectedUser.userId"
          [examTypes]="examTypes"
          (dialogClosed)="handleExamRecordDialogClose($event)"
        ></app-exam-record-dialog>
      </p-dialog>
    </div>
  }

  <div class="form-group" *ngIf="islead || isParticipant">
    <label>Bemerkungen</label>
    <p-editor [readonly]="!richTextEnabled" formControlName="misc" />
  </div>

  <!-- #endregion -->

  <div>
    <p>(* Pflichtfelder)</p>
  </div>

  @if (isUserSelected && isRoleLecturer && canWriteMeeting) {
    <p-divider />
    <app-teams-meeting-preview
      [selectedUser]="selectedUser"
    ></app-teams-meeting-preview>
  }

  <div class="form-buttons">
    @if (isUserSelected && isEditing) {
      <button
        pButton
        [loading]="isSubmitting"
        label=""
        title="Änderungen speichern"
        icon="pi pi-save"
        class="p-button-success"
        [disabled]="!newUserForm.valid"
        (click)="updateUser()"
      ></button>
    }
    @if (isUserSelected && !isEditing && canWriteUsers) {
      <button
        pButton
        [loading]="isSubmitting"
        label=""
        title="Nutzerdaten bearbeiten"
        icon="pi pi-pencil"
        class="p-button-success"
        (click)="enableEdit()"
      ></button>
    }
    @if ((islead || isParticipant) && !isUserSelected) {
      <button
        pButton
        [loading]="isSubmitting"
        label="+ Beratungsgespräch"
        title="Speichern und zum Beratungsgespräch"
        icon="pi pi-save"
        class="p-button-success"
        (click)="saveCreatedUser(true)"
        [disabled]="!newUserForm.valid"
      ></button>
    }
    @if (!isUserSelected) {
      <button
        pButton
        [loading]="isSubmitting"
        label=""
        icon="pi pi pi-save"
        class="p-button-success"
        (click)="saveCreatedUser(false)"
        [disabled]="!newUserForm.valid"
      ></button>
    }
    <button
      pButton
      [loading]="isSubmitting"
      title="Abbrechen"
      type="button"
      label="Abbrechen"
      icon="pi pi-times"
      class="p-button-secondary"
      (click)="closeDialog()"
    ></button>
  </div>
</form>
